import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, SxProps } from '@modusign/design-system';

import ResourceModalHeader from '@app/components/Modal/ResourceModal/ResourceModalHeader';

export interface ResourceModalHeaderWithBackButtonProps extends SxProps {
  title: React.ReactNode;
  resourceName: React.ReactNode;
  onBack?: () => void;
  onClose?: () => void;
}

function ResourceModalHeaderWithBackButton({
  title,
  resourceName,
  onBack,
  onClose,
}: ResourceModalHeaderWithBackButtonProps) {
  return (
    <ResourceModalHeader
      icon={
        onBack ? (
          <Box as="button" color="textNeutralLight" fontSize="18px" type="button" onClick={onBack}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Box>
        ) : undefined
      }
      resourceName={resourceName}
      title={title}
      onClose={onClose}
    />
  );
}

export default ResourceModalHeaderWithBackButton;
